import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { ClientResponse } from "../_model/client-response/client-response";
import { UserService } from "./user.service";
import { HistoryResponse } from "../_model/history-response/history-response";
@Injectable({
  providedIn: 'root'
})
export class ClientService {

  baseUrl = '/clients';

  constructor(private http: HttpClient, private userService: UserService) {
  }

  getClients(): Observable<ClientResponse> {
    return this.http.get<ClientResponse>(this.userService.getBaseUrl() + this.baseUrl + '/fmSystem/' + this.userService.getFmSystemId());
  }

  getClientsByFmsystemBrand(): Observable<ClientResponse> {
    return this.http.get<ClientResponse>(this.userService.getBaseUrl() + this.baseUrl + '/fmSystem/' + this.userService.getFmSystemId() + '/brandName' + '/' + this.userService.getBrand());
  }

  getDynamicClients(fmSystem: string): Observable<ClientResponse> {
      return this.http.get<ClientResponse>(this.userService.getBaseUrl() + this.baseUrl+ '/fmSystem/' + fmSystem);
  }

  getHistory(workOrderNumber: any): Observable<HistoryResponse> {
    return this.http.get<HistoryResponse>(this.userService.getBaseUrl() + '/workOrderHistory/brand/Rentokil' + '/fmSystem/' + this.userService.getFmSystemId() + '/workOrderId/' + workOrderNumber);
  }
}
